module.exports = __webpack_public_path__ + "media/two.d81c8d57.mp3";